import { IRootState } from '../../../store'
import { IItem } from '../store/timeline.types'

export const getSelectedItem = (state: IRootState): IItem | null => state.timeline.selectedItem
